import { IconSet } from './icon_set';

import nl from 'flagpack-core/svg/m/NL.svg';
import en from 'flagpack-core/svg/m/GB-UKM.svg';

const flags = new IconSet();

flags.register('en', en);
flags.register('nl', nl);

const getFlagIcon = (code) => flags.getIcon(code);

export {
    getFlagIcon
}